// z-index 管理器
class ZIndexManager {
    private baseZIndex = 1000; // 基础 z-index
    private currentZIndex = 1000; // 当前最高 z-index
    private windowMap = new Map<string, number>(); // 窗口 ID -> z-index 映射

    /**
     * 获取下一个最高的 z-index
     */
    getNextZIndex(): number {
        this.currentZIndex += 1;
        return this.currentZIndex;
    }

    /**
     * 注册窗口并获取 z-index
     * @param windowId 窗口唯一标识
     * @returns z-index 值
     */
    registerWindow(windowId: string): number {
        const zIndex = this.getNextZIndex();
        console.log('registerWindow', windowId, zIndex);
        this.windowMap.set(windowId, zIndex);
        return zIndex;
    }

    /**
     * 提升窗口到最高层级
     * @param windowId 窗口唯一标识
     * @returns 新的 z-index 值
     */
    bringToFront(windowId: string): number {
        const zIndex = this.getNextZIndex();
        this.windowMap.set(windowId, zIndex);
        return zIndex;
    }

    /**
     * 注销窗口
     * @param windowId 窗口唯一标识
     */
    unregisterWindow(windowId: string): void {
        this.windowMap.delete(windowId);
    }

    /**
     * 获取窗口当前的 z-index
     * @param windowId 窗口唯一标识
     * @returns z-index 值，如果窗口不存在则返回 null
     */
    getWindowZIndex(windowId: string): number | null {
        return this.windowMap.get(windowId) || null;
    }

    /**
     * 重置管理器（用于测试或清理）
     */
    reset(): void {
        this.currentZIndex = this.baseZIndex;
        this.windowMap.clear();
    }
}

// 导出单例
export const zIndexManager = new ZIndexManager();
